export default __webpack_public_path__ + "static/media/1.a422c579.png";